import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { ProgrammeList } from '~/components/programme-list';
import nemgyerek from '~/data/nemgyerek.json';
import { processProgrammeData } from '~/lib/programme-utils';
import { PageSection } from '~/routes/__root';

export const Route = createFileRoute('/program/daytime')({
  component: RouteComponent,
});

function RouteComponent() {
  // Process nemgyerek data to group by days
  const dailyData = React.useMemo(() => {
    return processProgrammeData(nemgyerek);
  }, []);

  const emptyMessage = {
    HU: 'Nincs még elérhető nappali program',
    EN: 'No daily programmes available yet',
    RS: 'Dnevni programi još nisu dostupni',
  };

  return (
    <PageSection width="narrow" padding="small">
      <ProgrammeList
        dailyData={dailyData}
        emptyMessage={emptyMessage}
        showAge={false}
      />
    </PageSection>
  );
}

export default RouteComponent;
